<template>
  <div class="mt-4 d-none d-md-block">
    <div class="w-100">
      <div class="block_top_prev_menu">
        <div class="wrapper">
          <b-link class="p-2 pr-4 pl-4" :to="{name: 'home'}" exact>{{ $t('menusections.home') }}</b-link>
          <b-link class="p-2 pr-4 pl-4" :to="{name: 'product_list', params: {listType: 'offers'}}">{{ $t('menusections.offers') }}</b-link>
          <b-link class="p-2 pr-4 pl-4" :to="{name: 'product_list', params: {listType: 'bestseller'}}">{{ $t('menusections.bestseller') }}</b-link>
          <b-link class="p-2 pr-4 pl-4" :to="{name: 'product_list', params: {listType: 'newproducts'}}">{{ $t('menusections.new_products') }}</b-link>
          <b-link class="p-2 pr-4 pl-4" :to="{name: 'grouped_categories'}">{{ $t('menusections.categories') }}</b-link>
          <b-link class="p-2 pr-4 pl-4" href="https://blog.globalstorepharma.com/" target="_blank">{{ $t('menusections.blog') }}</b-link>
        </div>
      </div>
      <div class="w-100">
        <CategoriesNavItem :categories="categoriesMenuTree"></CategoriesNavItem>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import CategoriesNavItem from "@/components/navigation/CategoriesNavItem";

export default {
  components: {
    CategoriesNavItem,
  },
  computed: {
    ...mapGetters("drugs", ["categoriesMenuTree"]),
  },
  fallbackI18n: {
    messages: {
      und: {
        menusections: {
          home: "Home",
          offers: "Offers",
          bestseller: "Best Seller",
          new_products: "New products",
          categories: "Categories",
          blog: "Blog",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.block_top_prev_menu {
  display: flex;

  .wrapper {
    display: flex;

    a {
      background-color: $gray-100;
      color: $gray-550;
      text-transform: uppercase;

      &:not(:last-of-type) {
        margin-right: 1px;
      }

      &:hover {
        color: $white;
        background-color: $corp-color1;
        text-decoration: solid;
      }
    }

    .active {
      color: $white;
      background-color: $corp-color1;
      text-decoration: solid;
    }

    .router-link-active {
      color: $white;
      background-color: $corp-color1;
      text-decoration: solid;
    }
  }
}
</style>
